import { Component, OnInit, OnDestroy, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, Renderer2, Input, SimpleChanges, OnChanges, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { SlickCarouselComponent } from "ngx-slick-carousel";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RequirementService } from 'src/app/services/requirement.service';
import { SendingIdService } from 'src/app/services/sending-id.service';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Email } from '../model/email.model';
import { SendingEmailService } from 'src/app/services/sending-email.service';
import { Observable, Subject, throwError } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ActivityAlertComponent } from '@flows/shared/pop-up/activity-alert/activity-alert.component';
import { AttachmentComponent } from '../pop-up/attachment/attachment.component';
import { SignatureAttachmentComponent } from '../pop-up/signature-attachment/signature-attachment.component';
import { LexgosignSendComponent } from '../pop-up/lexgosign-send/lexgosign-send.component';
import { LexgosignService, LexgosignEnvelope } from '@services/lexgosign.service';
import { EditAttachmentCategoryComponent } from '../pop-up/edit-attachment-category/edit-attachment-category.component';
import { getUserInfo } from '../../../util/auth/helpers';
import { CreateNoteComponent } from '../pop-up/create-note/create-note.component';
import { PortalClientMessagesModalComponent } from '../pop-up/portal-client-messages-modal/portal-client-messages-modal.component';
import { SendingUseridService } from 'src/app/services/sending-userid.service';
import { CalendarComponent } from '../pop-up/calendar/calendar.component';
import { DeleteAttachmentComponent } from '../pop-up/delete-attachment/delete-attachment.component';
import { DeleteAlertComponent } from '../pop-up/delete-alert/delete-alert.component';
import { EditAlertComponent } from '../pop-up/edit-alert/edit-alert.component';
import { EditActivityComponent } from '../pop-up/edit-activity/edit-activity.component';
import { DeleteActivityComponent } from '../pop-up/delete-activity/delete-activity.component';
import { DocumentTemplateComponent } from '../pop-up/document-template/document-template.component';
import { TemplateService } from '@services/template.service';
import { DomainConfigComponent } from '@app/domain-config.component';
import { LoadingService } from "src/app/services/loading.service";
import { ConfirmActionModalComponent } from "@app/trackvision/shared/components/confirm-action-modal/confirm-action-modal.component";
import { CollaboratorService } from '@services/collaborator.service';
import { DownloadAttachmentsComponent } from '../pop-up/download-attachments/download-attachments.component';
import { CostService } from '@services/cost.service';
import { ModalFormCostComponent } from '../pop-up/modal-form-cost/modal-form-cost.component';
import { PromptsAiComponent } from '../pop-up/prompts-ai/prompts-ai.component';
import { NgxPermissionsService } from 'ngx-permissions';
import { ModalFormFeeComponent } from '../pop-up/modal-form-fee/modal-form-fee.component';
import { AlertActionModalComponent } from "@app/trackvision/shared/pop-up/alert-action-modal/alert-action-modal.component";
import { SignatureService } from '@services/signature.service';
import { AttachmentsService } from 'src/app/services/attachments.service';
import { GoogleOAuthService } from 'src/app/services/google-oauth.service';
import { brand } from '@app/branding/brand';
import { environment } from 'src/environments/environment';
import {
	attachmentCategoryCssClass,
	attachmentCategoryLabel
} from '../../util/attachment-categories';
import { evaluateRequirementPortalChat } from '@app/shared/portal-chat/portal-chat-mode';
import { PORTAL_CHAT_MISCONFIGURED_MESSAGE } from '@app/shared/portal-chat/portal-chat-type-config.util';

@Component({
    selector: 'app-sidebar-req',
    templateUrl: './sidebar-req.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./sidebar-req.component.scss'],
    standalone: false
})
export class SidebarReqComponent implements OnInit, OnChanges, OnDestroy {

	/** Compile-time brand (InProvider / Thomson Reuters). */
	readonly brand = brand;

	//#region Variables
	@Input() isLoadHistory: boolean;
	@Input() dataUser;
	@ViewChild('base_r', { static: false }) base_r: ElementRef;
	public close_ = false;
	@Output() sentClose = new EventEmitter<boolean>();
	@Output() sentBackResult = new EventEmitter<boolean>();
	@Input() requirement:any = { owner: null };
	// Begin Activity and Alert
	@Input() idactivityAlertList: string;
	edicionActivityAlert: boolean = false;
	titelModalActivityAlert: string;
	// End
	// Begin Notes
	@Input() idnoteList: string;
	edicionNote: boolean = false;
	titelModalNote: string;
	getPath: string = 'trackvision/requirement/getnotebyid'
	// End
	message: string;
	isActive: boolean;
	showMenu: string;
	asignado: string = '';
	solicitante: string = '';
	showInformation: string = 'paperclip';
	requirementId = null;
	idUrl = null;
	files: Array<any>;
	logs: Array<any>;
	classIcon: string;
	id: number;
  loadingIA:boolean=false;
	//newcreatoremail = false;
	slideConfig = {
		slidesToShow: 3,
		slidesToScroll: 2,
		arrows: true,
		autoplay: false,
		dots: false,
		infinite: false
	};
	signatures = [];
	lexgosignEnvelopes: LexgosignEnvelope[] = [];
	/** true si public.configs → lexgosign.enabled (CLM Sign disponible en el select). */
	lexgosignEnabled = false;
	/** Proveedor activo en accordion Firmas: tufirma | lexgosign | docusign */
	signatureProvider: 'tufirma' | 'lexgosign' | 'docusign' = 'tufirma';
	records = [];
	title = 'ngSlick';
	slidesBaseList = ['fas fa-paperclip', 'far fa-clock', 'far fa-comment', 'far fa-user', 'fas fa-money-bill-wave', 'fas fa-hourglass-half', 'far fa-envelope', 'fas fa-comments', 'fas fa-money-bill-wave-alt'];
	slides: string[] = [];
	slides_names = {
		'fas fa-paperclip': 'Archivos',
		'far fa-clock': 'Alertas',
		'far fa-comment': 'Notas',
		'far fa-user': 'Colab.',
		'fas fa-money-bill-wave': 'Gastos',
		'fas fa-hourglass-half': 'Historial',
		'far fa-envelope': 'Enviar correo',
		'fas fa-comments': 'Comunicación externa',
		'far fa-edit': 'Firmas',
		'fas fa-file-code': 'Templates',
		'fas fa-money-bill-wave-alt': 'Honorarios'
	};
	slides_permission = [
		{name:'fas fa-paperclip',permissions: ['flows.requirement.file.access','flows.admin']},
		{name:'far fa-comment',permissions: ['flows.requirement.note.create','flows.admin']},
		{name:'far fa-clock',permissions: ['flows.requirement.alert.list','flows.admin']},
		{name:'fas fa-file-code',permissions: ['flows.requirement.template.list','flows.admin']},
		{name:'fas fa-money-bill-wave-alt',permissions: ['flows.requirement.fee.list','flows.admin']},
		{name:'far fa-envelope',permissions: ['flows.requirement.message.create','flows.admin']},
		{name:'fas fa-comments',permissions: ['flows.requirement.client.chat','flows.admin']},
		{name:'far fa-edit',permissions: ['flows.requirement.signature.create','flows.admin']},
		{name:'fas fa-money-bill-wave',permissions: ['flows.requirement.bills.list','flows.admin']},
		{name:'far fa-user',permissions: ['flows.requirement.collaborators.list','flows.admin']},
		{name:'fas fa-hourglass-half',permissions: ['flows.requirement.history.access','flows.admin']},
	];
	analisys_submitted = false;

	@ViewChild('slickModal', { static: true }) slickModal: SlickCarouselComponent;
	cc: boolean = false;
	cco: boolean = false;
	//Quill Editor Config
	config = {
		toolbar: [
			['bold', 'italic', 'underline'],
			[{ 'size': ['small', false, 'large', 'huge'] }],
			[{ 'list': 'ordered' }, { 'list': 'bullet' }]
		]
	};
	newEmail: Email = new Email();
	formSubmitted: boolean = false;
	newFiles: Array<any>;
	masterSelected: boolean;
	checkedList: any;
	checkedList1: any;
	listAttachments: Array<any>;
	errorMessage: string = '';
	private _success = new Subject<string>();
	private _error = new Subject<string>();
	successMessage = '';
	idReq: number;
	usersSuscribed: Array<any>;
	name: string;
	loading: boolean = false;
	actvAlertHistory: Array<any>;
	userProfile: string = '';
	dataNote: Array<any> = [];
	filesLoading: boolean = false;
	driveConnected: boolean = false;
	driveEmail: string | null = null;
	// El Drive conectado es de otra persona (caso típico: cuenta compartida donde
	// alguien conectó su Drive personal y el siguiente que entra sube ahí sin saberlo).
	driveForeignAccount: boolean = false;
	private _onFocus: () => void;
	alertLoading: boolean = false;
	noteLoading: boolean = false;
	recordsLoading: boolean = false;
	collaboratorLoading: boolean = false;
	costLoading: boolean = false;
	displayDialog: boolean;
	respLoadHistory: boolean;
	currentUserId: number;
	templates: any[] = [];

	isVisibleFirma: boolean = false;
	isVisibleTemplate: boolean = false;
	isVisibleCosts: boolean = false;
	collaborators: any = []
	formCollaborator: FormGroup
	isOwner: boolean;
	isCreator: boolean;
	costs: any = [];
	fee:any = [];
  	uri: string = '';
	permissionAddColaborator:any;
	dataEmailHistory:Array<any> = [];
	dataPortalclientComments: Array<any> = [];
	portalclientCommentNote = '';
	portalclientCommentFile: File | null = null;
	sendingPortalclientComment = false;
	advancedSignaturesAvailable: number = 0;

	constructor(
		public router: Router,
		private activatedRoute: ActivatedRoute,
		public _requirements: RequirementService,
		private modalService: NgbModal,
		private sendIdServ: SendingIdService,
		private sendEmailServ: SendingEmailService,
		private sendUserIdServ: SendingUseridService,
		private renderer: Renderer2,
		private _templateService: TemplateService,
		private domainConfigComponent: DomainConfigComponent,
		private _loading: LoadingService,
		private collaboratorService: CollaboratorService,
		private costService: CostService,
		private formBuilder: FormBuilder,
		private permissionsService: NgxPermissionsService,
		private signatureService: SignatureService,
		private attachmentsService: AttachmentsService,
		private googleOAuth: GoogleOAuthService,
		private lexgosignService: LexgosignService
	) {
		this.masterSelected = false;
		this.isVisibleFirma = this.domainConfigComponent.getConfigFlagFirma('visible');
		this.isVisibleTemplate = this.domainConfigComponent.getConfigFlagTemplate('visible');
		this.isVisibleCosts = this.domainConfigComponent.getConfigFlagCosts('visible');
		if (this.isVisibleFirma) {
			this.slidesBaseList.push('far fa-edit');
		}
		if (this.isVisibleTemplate) {
			this.slidesBaseList.push('fas fa-file-code');
		}

		if (this.isVisibleCosts) {
			this.slidesBaseList.push('fas fa-money-bill-wave');
		}

		this.formCollaborator = this.formBuilder.group({
			'requirementid': [''],
			'userid': ['', Validators.required],
			'reason': ['']
		})

	}

	/** Categoría de adjuntos: lee siempre el flag vivo de domain config. */
	get enableAttachmentCategories(): boolean {
		const flag = this.domainConfigComponent.getConfigFlag('attachmentCategories');
		return flag === true || flag === 'true' || flag === 1 || flag === '1';
	}

	ngOnInit() {
		this.permissionAddColaborator = this.permissionsService.getPermission('trackvision.users.addcollaborator') ? this.permissionsService.getPermission('trackvision.users.addcollaborator') : this.permissionsService.getPermission('flows.admin');
		this.uri = this.getCurrentUrl();
		this.requirementId = this.activatedRoute.snapshot.paramMap.get('requirementId');
		this.sendIdServ.sendId(this.requirementId);
		this.idReq = this.requirement['id'];
		this.usersSuscribed = this.requirement['usersSuscribed'];
		this.solicitante = this.requirement['creator'];
		this.asignado = this.requirement['owner'];

		// Reload files when user returns from editor tab
		this._onFocus = () => this.loadFiles();
		window.addEventListener('focus', this._onFocus);

		this.isActive = false;
		this.showMenu = '';
		/* this is for messages */
		this.messagesSubmitForm();
		// Disable an Icon Doc
		const userInfo = getUserInfo();

		this.validateOwner();
		this.validateCreator();

		this.sendUserIdServ.sendUserId(userInfo.data.id);
		this.currentUserId = userInfo.data.id;
		this.getCollaboratorsToAdd()
		// LOADING MODULES
		this.loadFiles();
		this.loadHistory();
		this.loadAlerts();
		this.loadNotes();
		this.loadTemplateRecords();
		this.loadSignatures();
		this.loadLexgosignAvailability();
		this.loadCosts();
		this.loadEmailHistory();
		this.loadPortalclientComments();

		// display the modal calendar
		this.activatedRoute.queryParams.subscribe(params => {
			this.displayDialog = params['show_calendar'] || false;
			if (this.displayDialog) {
				this.calendarPopup();
			}
		});
		this.buildSlides();
		this.loadAvailableSignatures();
	}

  private buildSlides(): void {
    let existPersimission = false;
    const slideTmp: string[] = [];
    this.slidesBaseList.forEach((x, i) => {
      const slidePermission = this.slides_permission.find(f => f.name === x);
      if (slidePermission) {
        for (const permission of slidePermission.permissions) {
          existPersimission = !!this.permissionsService.getPermission(permission);
          if (existPersimission) {
            if (x === 'fas fa-comments' && !this.hasPortalChatSectionVisible) { existPersimission = false; break; }
            slideTmp.push(this.slidesBaseList[i]);
            break;
          }
        }
        existPersimission = false;
      }
    });
    this.slides = slideTmp;
  }

  containsText(text: string): boolean {
    return this.slides.includes(text);
  }

	ngOnChanges(changes: SimpleChanges): void {
		if (this.isLoadHistory) {
			this.loadHistory();
			this.loadAlerts();
			setTimeout(() => {
				this.sentBackResult.emit(false);
			}, 100);

		}
		if (changes.requirement) {
			this.asignado = changes.requirement.currentValue['owner'];
			// Recargar colaboradores cuando cambie el requirement
			if (changes.requirement.currentValue && changes.requirement.currentValue.requirementtypeid) {
				this.getCollaboratorsToAdd();
			}
			// Reconstruir slides según portalChat del tipo (active / misconfigured / disabled)
			this.buildSlides();
		}
	}

	close_rigth() {
		this.close_ = false ? this.close_ == true : this.close_ == false;
		this.sentClose.emit(this.close_);
	}

	// disable enter click on an input
	prevent(event) {
		event.preventDefault();
	}
	next() {
		this.slickModal.slickNext();
	}
	prev() {
		this.slickModal.slickPrev();
	}
	sendIcon(icon: string) {
		this.showInformation = icon;
	}
	//form sending email
	submitEmail(form: NgForm) {
		this.formSubmitted = true;
		if (form.valid) {
			this.loading = true;
			this.newEmail.attachments = this.listAttachments || [];
			this.newEmail.id = this.idReq;
			// Asegurar que content siempre esté presente, incluso si está vacío
			if (!this.newEmail.content) {
				this.newEmail.content = '';
			}

			// Agregar el email del usuario que envía al CC
			if (this.dataUser && this.dataUser.email) {
				if (this.newEmail.cc && this.newEmail.cc.trim() !== '') {
					// Si ya hay un CC, agregar el email del usuario separado por coma
					this.newEmail.cc = `${this.newEmail.cc}, ${this.dataUser.email}`;
				} else {
					// Si no hay CC, establecer el email del usuario
					this.newEmail.cc = this.dataUser.email;
				}
			}

			this.sendEmailServ.getSendingEmail(this.newEmail).subscribe(resp => {
				if (resp.hasOwnProperty('error')) {
					this.loading = false;
					this._error.next('No se pudo enviar el correo!!.');

				} else if(resp.hasOwnProperty('result')){
					this.loading = false;
					this._success.next('Mensaje enviado.');
					this.loadHistory();
					this.loadEmailHistory();
				}else{
					this.loading = false;
					this._error.next('No se pudo enviar el correo!!.');
				}
			});
			// Reset of variables
			this.listAttachments = [];
			this.newEmail = new Email();
			form.reset();
			this.formSubmitted = false;
		}
	}

	getValidationMessages(state: any, thingName?: string) {
		let thing: string = state.path || thingName;
		let messages: string[] = [];
		if (state.errors) {
			// tslint:disable-next-line: forin
			for (let errorName in state.errors) {
				switch (errorName) {
					case "required":
						messages.push(`Este campo es obligatorio ${thing}`);
						break;
					case "pattern":
						messages.push('Introduzca una dirección de correo electrónico válida');
						break;
				}
			}
		}
		return messages;
	}

	onLoggedout() {
		localStorage.removeItem('isLoggedin');
	}

	//Mensaje Nuevo
	changeCc(): void {
		this.cc = true;
	}
	changeCco(): void {
		this.cco = true;
	}

	// CHEBOX LIST
	checkUncheckAll() {
		for (var i = 0; i < this.newFiles.length; i++) {
			this.newFiles[i].isSelected = this.masterSelected;
		}
		this.getCheckedItemList(this.newFiles);
	}
	isAllSelected() {
		// The every() method checks if all elements in an array pass a test (provided as a function).
		this.masterSelected = this.newFiles.every(function (item: any) {
			return item.isSelected == true;
		});
		this.getCheckedItemList(this.newFiles);
	}
	getCheckedItemList(newFiles: Array<any>) {
		this.checkedList = [];
		for (let i = 0; i < newFiles.length; i++) {
			if (newFiles[i].isSelected)
				this.checkedList.push(newFiles[i]);
		}
		this.listAttachments = this.checkedList.map(v => ({ filename: v.filename, path: v.url }));
	}

	/* POPUP */
	// Alert
	openAlertModule(idAvtivity) {
		if (idAvtivity !== null) {
			this.idactivityAlertList = idAvtivity.toString();
			this.edicionActivityAlert = true;
			this.titelModalActivityAlert = 'Editar Actividades y Alertas';
		} else {
			this.idactivityAlertList = null;
			this.edicionActivityAlert = false;
			this.titelModalActivityAlert = 'Crear Actividades y Alertas'
		}
		const modalRef = this.modalService.open(ActivityAlertComponent, { scrollable: true, size: 'md', backdrop: 'static', keyboard: false });
		modalRef.componentInstance.requirementId = this.requirementId;
		modalRef.componentInstance.idactivityAlert = this.idactivityAlertList;
		modalRef.componentInstance.edicion = this.edicionActivityAlert;
		modalRef.componentInstance.titelModal = this.titelModalActivityAlert;
		modalRef.componentInstance.insertAlert.subscribe(insertAlert => {
			if (insertAlert) {
				this.alertLoading = true;
				this.loadAlerts();
				this.loadHistory();
			}
		});
	}
	// Archivo
	uploadFile() {
		const modalRef = this.modalService.open(AttachmentComponent, {
			scrollable: true, size: 'lg', backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.service = 'trackvision';
		modalRef.componentInstance.typeId = 'requirementid';
		modalRef.componentInstance.enableCategory = this.enableAttachmentCategories;
		// modalRef.componentInstance.method = this._requirements.uploadOneFile;
		modalRef.componentInstance.insertAttach.subscribe(insertAttach => {
			if (insertAttach) {
				this.filesLoading = true;
				this.loadFiles();
				this.loadHistory();
			}
		});
	}

	attachmentCategoryDisplay(file: { category?: string; categoryother?: string }): string {
		return attachmentCategoryLabel(file?.category, file?.categoryother);
	}

	attachmentCategoryClass(category?: string): string {
		return attachmentCategoryCssClass(category);
	}

	downloadFiles() {
		const modalRef = this.modalService.open(DownloadAttachmentsComponent, {
			size: 'md', backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.idReq = this.requirementId;
	}

	// Create Signature
	createSignature() {
		if (this.signatureProvider === 'lexgosign' && this.lexgosignEnabled) {
			this.createLexgosign();
			return;
		}
		const modalRef = this.modalService.open(SignatureAttachmentComponent, {
			scrollable: true,
			size: 'xl',
			backdrop: 'static',
			keyboard: false,
		});
		modalRef.componentInstance.requirementId = this.requirementId;
		modalRef.componentInstance.service = 'trackvision';
		modalRef.componentInstance.typeId = 'requirementid';
		if (this.signatureProvider === 'docusign') {
			modalRef.componentInstance.signatureType = 'docusign';
			modalRef.componentInstance.showMultipleSignatureTypes = true;
		}
		modalRef.componentInstance.insertAttach.subscribe(insertAttach => {
			if (insertAttach) {
				this.filesLoading = true;
				this.loadFiles();
				this.loadHistory();
				this._requirements.getSignatures('trackvision/signature/' + this.requirementId).subscribe(
					(data: any) => {
						this.signatures = data.result || [];
					},
					error => {
						this._error.next('Error al cargar la actividad.');
					}
				);
			}
		});
	}

	createLexgosign() {
		const modalRef = this.modalService.open(LexgosignSendComponent, {
			scrollable: true,
			size: 'xl',
			backdrop: 'static',
			keyboard: false,
			windowClass: 'lexgosign-send-modal'
		});
		modalRef.componentInstance.requirementId = this.requirementId;
		modalRef.componentInstance.sent.subscribe((ok: boolean) => {
			if (ok) {
				this.loadLexgosignEnvelopes();
				this.loadFiles();
			}
		});
		modalRef.result.then(
			() => this.loadLexgosignEnvelopes(),
			() => {}
		);
	}

	onSignatureProviderChange() {
		if (this.signatureProvider === 'lexgosign' && this.lexgosignEnabled) {
			this.loadLexgosignEnvelopes();
			return;
		}
		if (this.signatureProvider === 'docusign') {
			this.loadSignatures();
			return;
		}
		this.signatureProvider = 'tufirma';
		this.loadSignatures();
	}

	loadLexgosignAvailability() {
		this.lexgosignService.isEnabled().subscribe({
			next: (enabled) => {
				this.lexgosignEnabled = !!enabled;
				if (!this.lexgosignEnabled) {
					this.signatureProvider = 'tufirma';
					this.lexgosignEnvelopes = [];
					return;
				}
				this.loadLexgosignEnvelopes();
			},
			error: () => {
				this.lexgosignEnabled = false;
				this.signatureProvider = 'tufirma';
				this.lexgosignEnvelopes = [];
			}
		});
	}

	loadLexgosignEnvelopes() {
		if (!this.lexgosignEnabled || !this.requirementId) {
			this.lexgosignEnvelopes = [];
			return;
		}
		this.lexgosignService.listByRequirement(this.requirementId).subscribe(
			(list) => {
				this.lexgosignEnvelopes = Array.isArray(list) ? list : [];
			},
			() => {
				this.lexgosignEnvelopes = [];
			}
		);
	}

	// Create Signature
	createTemplates() {
		const modalRef = this.modalService.open(DocumentTemplateComponent, {
			scrollable: true, size: 'lg', backdrop: 'static',
			keyboard: false,
		});
		modalRef.componentInstance.requirementId = this.requirementId;
		modalRef.componentInstance.service = 'trackvision';
		modalRef.componentInstance.typeId = 'requirementid';
		modalRef.componentInstance.insertTemplate.subscribe(insertTemplate => {
			if (insertTemplate) {
				// this.templatesLoading = true;
				this.loadTemplateRecords();
				this.loadFiles();
				this.loadHistory();
			}
		});
	}

	// Note
	createNote(idNote) {
		let servicePath: string;
		if (idNote !== null) {
			this.idnoteList = idNote.toString();
			this.edicionNote = true;
			this.titelModalNote = 'Editar Notas';
			servicePath = 'trackvision/requirement/editnote';
		} else {
			this.idnoteList = null;
			this.edicionNote = false;
			this.titelModalNote = 'Crear Notas'
			servicePath = 'trackvision/requirement/addnote';
		}
		const modalRef = this.modalService.open(CreateNoteComponent, {
			scrollable: true, size: 'md', backdrop: 'static',
			keyboard: false
		});

		modalRef.componentInstance.requirementId = this.requirementId;
		modalRef.componentInstance.requirementtypeid = this.requirement.requirementtypeid;
		modalRef.componentInstance.path = servicePath;
		modalRef.componentInstance.getPath = this.getPath;
		modalRef.componentInstance.titelModal = this.titelModalNote;
		modalRef.componentInstance.idnote = this.idnoteList;
		modalRef.componentInstance.edicion = this.edicionNote;
		modalRef.componentInstance.insertNote.subscribe(insertNote => {
			if (insertNote) {
				this.noteLoading = true;
				this.loadNotes();
				this.loadHistory();
			}
		});
	}

	openPortalClientMessagesModal() {
		if (this.hasPortalChatMisconfigured) {
			const alertModal = this.modalService.open(AlertActionModalComponent, { size: 'sm', centered: true });
			alertModal.componentInstance.message = PORTAL_CHAT_MISCONFIGURED_MESSAGE;
			return;
		}
		const modalRef = this.modalService.open(PortalClientMessagesModalComponent, {
			scrollable: true, size: 'lg', backdrop: 'static', keyboard: false
		});
		modalRef.componentInstance.requirementId = this.requirementId;
	}

	// calender
	calendarPopup() {
		const modalRef = this.modalService.open(CalendarComponent, {
			scrollable: true, size: 'xl', backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.requirementId = this.requirementId;
		modalRef.componentInstance.closeCalendar.subscribe(closeCalendar => {
			if (closeCalendar) {
				this.alertLoading = true;
				this.loadAlerts();
				this.loadHistory();
			}
		});
	}

	/* Delete a file*/
	deleteItem(id: number) {
		const modalRef = this.modalService.open(DeleteAttachmentComponent, {
			size: 'md', backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.idFile = id;
		modalRef.componentInstance.title = 'archivo';
		modalRef.componentInstance.service = 'trackvision';
		modalRef.componentInstance.deleteFile.subscribe(deleteFile => {
			if (deleteFile) {
				this.filesLoading = true;
				this.loadFiles();
				this.loadHistory();
			}
		});
	}

	editCategory(file: { id: number; filename?: string; category?: string; categoryother?: string }) {
		if (!file?.id || !this.enableAttachmentCategories) {
			return;
		}
		const modalRef = this.modalService.open(EditAttachmentCategoryComponent, {
			size: 'md',
			backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.attachmentId = file.id;
		modalRef.componentInstance.filename = file.filename || '';
		modalRef.componentInstance.category = file.category || '';
		modalRef.componentInstance.categoryother = file.categoryother || '';
		modalRef.componentInstance.categoryUpdated.subscribe((updated: boolean) => {
			if (updated) {
				this.filesLoading = true;
				this.loadFiles();
			}
		});
	}

	ondeleteNoteEmit(e) {
		if (e) {
			this.noteLoading = true;
			this.loadNotes();
			this.loadHistory();
		}
	}

  onDeleteTemplateEmit(e) {
		if (e) {
      this.loadTemplateRecords();
		}
	}

	// delete an alert
	deleteAlert(id: number) {
		const modalRef = this.modalService.open(DeleteAlertComponent, {
			size: 'md', backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.idFile = id;
		modalRef.componentInstance.title = 'actividades y alertas';
		modalRef.componentInstance.deleteFile.subscribe(deleteFile => {
			if (deleteFile) {
				this.alertLoading = true;
				this.loadAlerts();
				this.loadHistory();
			}
		});
	}

	// edit alert
	editAlert(idAlert: number, idActv: number) {
		const modalRef = this.modalService.open(EditAlertComponent, {
			scrollable: true, size: 'md', backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.idAlert = idAlert;
		modalRef.componentInstance.idActivity = idActv;
		modalRef.componentInstance.reqId = this.requirementId;
		modalRef.componentInstance.confirmAlert.subscribe(confirmAlert => {
			if (confirmAlert) {
				this.alertLoading = true;
				this.loadAlerts();
				this.loadHistory();
			}
		});
	}

  refreshNote($event){
    this.loadNotes();
    this.loadHistory();
  }

	// Activity edit and delete
	deleteActivity(idActv: number) {
		const modalRef = this.modalService.open(DeleteActivityComponent, {
			size: 'md', backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.idFile = idActv;
		modalRef.componentInstance.title = 'actividad';
		modalRef.componentInstance.deleteFile.subscribe(deleteFile => {
			if (deleteFile) {
				this.alertLoading = true;
				this.loadAlerts();
				this.loadHistory();
			}
		});
	}

	editActivity(idActv: number) {
		const modalRef = this.modalService.open(EditActivityComponent, {
			scrollable: true, size: 'md', backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.idActivity = idActv;
		modalRef.componentInstance.reqId = this.requirementId;
		modalRef.componentInstance.insertEditActv.subscribe(insertEditActv => {
			if (insertEditActv) {
				this.alertLoading = true;
				this.loadAlerts();
				this.loadHistory();
			}
		});
	}

	/* DONE */
	// Messages for submit
	messagesSubmitForm() {
		this._success.subscribe(message => this.successMessage = message);
		this._success.pipe(
			debounceTime(3000)
		).subscribe(() => this.successMessage = '');
		this._error.subscribe(message => this.errorMessage = message);
		this._error.pipe(
			debounceTime(3000)
		).subscribe(() => this.errorMessage = '');
	}

	/* LOAD SINGEL MODULES */
	loadFiles() {

		this._requirements.getRequirementAllData(this.requirementId).subscribe(resp => {
			if (resp['error']) {
				throw Error('Service Error');
			} else {
				this.files = resp['result']['attachments'];
				this.filesLoading = false;
				// insert new field into newFiles array
				this.newFiles = this.files.map((el) => {
					let o = Object.assign({}, el);
					o.isSelected = false;
					return o;
				});
				this.getCheckedItemList(this.newFiles);
				// Load last edit info for editable files
				this.files.forEach(file => {
					const ext = (file.filename || '').split('.').pop().toLowerCase();
					if (['docx','xlsx','pptx','odt','ods','odp'].includes(ext)) {
						this.attachmentsService.getEditHistory(file.id).subscribe((res: any) => {
							if (res.result && res.result.history && res.result.history.length > 0) {
								file.lastEdit = res.result.history[0];
							}
						});
					}
				});
				this.loadDriveLinks();
			}
		});
	}

	/**
	 * Estado de Google Drive + enlaces ya generados, en una sola llamada por requerimiento
	 * (a diferencia del historial de edición, que sí va archivo por archivo).
	 */
	loadDriveLinks() {
		this.attachmentsService.getDriveLinks(this.requirementId).subscribe((res: any) => {
			if (res.error) return;
			const data = res.result || {};
			this.driveConnected = !!data.connected;
			this.driveEmail = data.email || null;
			this.driveForeignAccount = !!data.foreignAccount;

			const byAttachment = new Map<number, any>();
			(data.links || []).forEach((link: any) => byAttachment.set(Number(link.attachmentid), link));
			this.files.forEach(file => { file.drive = byAttachment.get(Number(file.id)) || null; });
		});
	}

	/**
	 * Mismo flujo que "Vincular cuentas" del perfil: un solo consentimiento deja la
	 * identidad vinculada y Drive habilitado. Por eso desde aquí también se vincula
	 * la cuenta, no solo se pide el permiso de archivos.
	 */
	connectDrive() {
		this.googleOAuth.openGoogleConnectPopup()
			.then(({ email }) => {
				this.driveConnected = true;
				this.driveEmail = email || null;
				// Acaba de consentir con su propia cuenta, así que no hay nada que advertir.
				this.driveForeignAccount = false;
			})
			.catch((err) => {
				// Popup cerrado por el usuario: no es un error que valga la pena mostrar.
				if (err?.message === 'Timeout') return;
				alert(err?.message || 'No se pudo conectar la cuenta de Google');
			});
	}

	sendToDrive(file: any) {
		if (file.driveSending) return;
		file.driveSending = true;

		this.attachmentsService.sendToDrive(file.id).subscribe({
			next: (res: any) => {
				file.driveSending = false;
				if (res.error) {
					// El backend borra la credencial cuando Google la rechaza. En vez de
					// adivinar leyendo el texto del error, releemos el estado real.
					this.loadDriveLinks();
					alert(res.error.message || 'No se pudo enviar el archivo a Google Drive');
					return;
				}
				file.drive = res.result;
			},
			error: () => {
				file.driveSending = false;
				alert('No se pudo enviar el archivo a Google Drive');
			}
		});
	}

	/**
	 * Fase 2: trae los cambios desde Google Drive y pisa el adjunto en Inprovider.
	 * Visible solo si el archivo ya fue enviado a Drive (file.drive existe).
	 */
	pullFromDrive(file: any) {
		if (file.drivePulling) return;

		if (!this.driveConnected) {
			// Ofrecer conectar ahí mismo (definición Natalia 7-ago)
			if (confirm('No tienes una cuenta de Google conectada. ¿Deseas conectarla ahora?')) {
				this.connectDrive();
			}
			return;
		}

		file.drivePulling = true;

		this.attachmentsService.pullFromDrive(file.id).subscribe({
			next: (res: any) => {
				file.drivePulling = false;
				if (res.error) {
					this.loadDriveLinks();
					alert(res.error.message || 'No se pudieron traer los cambios desde Google Drive');
					return;
				}
				// Actualizar el filename si cambió (ej. .doc → .docx)
				if (res.result && res.result.filename) {
					file.filename = res.result.filename;
				}
				// Recargar archivos y historial para reflejar el cambio
				this.loadFiles();
				this.loadHistory();
			},
			error: () => {
				file.drivePulling = false;
				alert('No se pudieron traer los cambios desde Google Drive');
			}
		});
	}

	loadHistory() {
		this._requirements.getRequirementAllData(this.requirementId).subscribe(resp => {
			this.logs = resp['result']['logs'];
		});
	}
	loadAlerts() {
		// Getting history activities alerts
		this._requirements.getAllActvAlerts(this.requirementId).subscribe(resp => {
			if (resp['error']) {
				throw Error('Service Error');
			} else {
				this.alertLoading = false;
				this.actvAlertHistory = this.formatDate(resp['result']);
			}
		});
	}

	formatDate(arrayy) {
		return arrayy.map((item) => {
			const act = item.activity;
			if (act?.date_activity != null && typeof act.date_activity === 'string') {
				act.date_activity = act.date_activity.split('T')[0];
			}
			if (Array.isArray(item.alert)) {
				item.alert.forEach((al: { date_before_activity?: string }) => {
					if (al?.date_before_activity != null && typeof al.date_before_activity === 'string') {
						al.date_before_activity = al.date_before_activity.split('T')[0];
					}
				});
			}
			return item;
		});
	}

	/** Fecha YYYY-MM-DD para enlaces de calendario (reloj local si hay `activity_at`). */
	activityCalendarStartDate(activity: { activity_at?: string; date_activity?: string } | null | undefined): string {
		if (!activity) return '';
		if (activity.activity_at) {
			const d = new Date(activity.activity_at);
			if (!Number.isNaN(d.getTime())) {
				const y = d.getFullYear();
				const m = String(d.getMonth() + 1).padStart(2, '0');
				const day = String(d.getDate()).padStart(2, '0');
				return `${y}-${m}-${day}`;
			}
		}
		return activity.date_activity ?? '';
	}

	/** Hora HH:mm:ss para calendario (reloj local si hay `activity_at`). */
	activityCalendarHourStart(activity: { activity_at?: string; hour_activity?: string } | null | undefined): string {
		if (!activity) return '';
		if (activity.activity_at) {
			const d = new Date(activity.activity_at);
			if (!Number.isNaN(d.getTime())) {
				const hh = String(d.getHours()).padStart(2, '0');
				const mm = String(d.getMinutes()).padStart(2, '0');
				const ss = String(d.getSeconds()).padStart(2, '0');
				return `${hh}:${mm}:${ss}`;
			}
		}
		return (activity.hour_activity as string) ?? '';
	}

	alertCalendarStartDate(alert: { alert_at?: string; date_before_activity?: string } | null | undefined): string {
		if (!alert) return '';
		if (alert.alert_at) {
			const d = new Date(alert.alert_at);
			if (!Number.isNaN(d.getTime())) {
				const y = d.getFullYear();
				const m = String(d.getMonth() + 1).padStart(2, '0');
				const day = String(d.getDate()).padStart(2, '0');
				return `${y}-${m}-${day}`;
			}
		}
		return alert.date_before_activity ?? '';
	}

	alertCalendarHourStart(alert: { alert_at?: string; hour_before_activity?: string } | null | undefined): string {
		if (!alert) return '';
		if (alert.alert_at) {
			const d = new Date(alert.alert_at);
			if (!Number.isNaN(d.getTime())) {
				const hh = String(d.getHours()).padStart(2, '0');
				const mm = String(d.getMinutes()).padStart(2, '0');
				const ss = String(d.getSeconds()).padStart(2, '0');
				return `${hh}:${mm}:${ss}`;
			}
		}
		return (alert.hour_before_activity as string) ?? '';
	}

	loadNotes() {
		// getting notes list
		this._requirements.getNote(this.requirementId).subscribe(resp => {
			this.noteLoading = false;
			this.dataNote = resp['result'];
		});
	}
	loadTemplateRecords() {
		// getting template records
		this._templateService.getTemplateRecords(this.requirementId).subscribe(resp => {
			this.recordsLoading = false;
			this.records = resp['result'];
		});
	}
	loadSignatures() {
		this._requirements.getSignatures('trackvision/signature/' + this.requirementId).subscribe(
			(data: any) => {
				this.signatures = data.result || [];
			},
			error => {
				this._error.next('Error al cargar la actividad.');
			}
		);
	}
	loadCollaborators() {
		this._requirements.getRequirementAllData(this.requirementId).subscribe((resp) => {
			this.usersSuscribed = resp['result']['usersSuscribed'];
			this.collaboratorLoading = false;
		})
	}

	loadCosts() {
		this.costLoading = true;
		this.costService.getCostsByRequirementId(this.requirementId).subscribe({
			next: (resp) => {
				this.costs = resp['result']?.costs ?? [];
				this.fee = resp['result']?.fee ?? [];
				this.costLoading = false;
			},
			error: () => {
				this.costs = [];
				this.fee = [];
				this.costLoading = false;
			}
		});
	}

	/**
	 * allows to load the history of sent messages
	 */
	loadEmailHistory() {
		this._requirements.getEmailHistory(this.requirementId).subscribe(resp => {
			this.noteLoading = false;
			this.dataEmailHistory= resp['result'];
		});
	}

	loadPortalclientComments() {
		if (!this.requirementId) return;
		this._requirements.getPortalclientComments(this.requirementId).subscribe({
			next: (resp: any) => {
				const data = resp?.result ?? resp;
				this.dataPortalclientComments = Array.isArray(data) ? data : [];
				// No marcar como leído aquí: solo se marca al abrir el modal "Chat con el cliente"
			},
			error: () => { this.dataPortalclientComments = []; }
		});
	}

	onPortalclientCommentFileSelected(event: Event) {
		const input = event.target as HTMLInputElement;
		this.portalclientCommentFile = input.files?.length ? input.files[0] : null;
	}

	submitPortalclientComment() {
		const note = (this.portalclientCommentNote || '').trim();
		if ((!note && !this.portalclientCommentFile) || !this.requirementId || this.sendingPortalclientComment) return;
		this.sendingPortalclientComment = true;
		this._requirements.addPortalclientComment(this.requirementId, note || '(archivo adjunto)', this.portalclientCommentFile || undefined).subscribe({
			next: () => {
				this.portalclientCommentNote = '';
				this.portalclientCommentFile = null;
				const fileInput = document.querySelector('input[name="portalclientCommentFile"]') as HTMLInputElement;
				if (fileInput) fileInput.value = '';
				this.sendingPortalclientComment = false;
				this.loadPortalclientComments();
			},
			error: () => { this.sendingPortalclientComment = false; }
		});
	}

	formatPortalclientDate(d: string | Date): string {
		if (!d) return '-';
		const date = new Date(d);
		return date.toLocaleDateString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric' }) + ' ' +
			date.toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' });
	}

	/* Click Events */
	loadingNote(event) {
		if (event) {
			this.loadNotes();
			this.loadHistory();
		}
	}



	onLoadHistoryLog(e) {
		this.loadHistory();
	}

	deleteRequirement() {
		const confirmModal = this.modalService.open(ConfirmActionModalComponent, { size: 'sm', centered: true });
		confirmModal.componentInstance.message = `¿Estás seguro de eliminar este Requerimiento?`;
		confirmModal.result.then((confirmed) => {
			if (confirmed) {
				this._loading.reloadStart(null, this._loading.blockUIList);
				this._requirements.deleteRequirement(this.requirementId, 'trackvision/requirement/delete').subscribe((resp) => {
					if (resp["result"] === true) {
						this.router.navigate(["/flows/requirements"]);
					} else {
						alert("error al eliminar requerimiento");
					}
					this._loading.reloadStop(this._loading.blockUIList);
				},
					error => {
						this._loading.reloadStop(this._loading.blockUIList);
					});
			}
		}).catch();

		return;
	}

	onLoadCosts(event) {
		if (event) {
			this.costLoading = true
			this.loadCosts();
		}
	}


	//#region Obtener Colaboradores (usuarios con visibilidad de colaborador)
	getCollaboratorsToAdd() {
		if (!this.requirement || !this.requirement.requirementtypeid) {
			console.warn('requirement o requirementtypeid no está disponible');
			return;
		}
		this.collaboratorService.listCollaborators(this.requirement.requirementtypeid).subscribe(
			data => {
				// El endpoint devuelve directamente un array, no un objeto con 'result'
				const result = Array.isArray(data) ? data : (data['result'] || []);
				this.collaborators = result.map((user:any) => {
					return {
						id: user.id,
						text: user.name || user.text || user.email
					};
				});
			},
			error => {
				console.error('Error al cargar los colaboradores:', error);
				this.collaborators = [];
			}
		);
	}
	//#endregion

	//#region Abrir Modal para Confirmar Agregar Colaborador
	openModalToAddCollaborator() {
		if (this.formCollaborator.invalid) {
			return;
		}
		const confirmModal = this.modalService.open(ConfirmActionModalComponent, { size: 'sm', centered: true });
		confirmModal.componentInstance.message = `¿Deseas agregar el colaborador al requerimiento?`;
		confirmModal.result.then((confirmed) => {
			if (confirmed) {
				this.addCollaborator()
			}
		}).catch();

		return;
	}
	//#endregion

	//#region Funcionalidad Agregar Colaborador
	addCollaborator() {
		let collaborator = this.formCollaborator.value
		collaborator.requirementid = this.requirementId

		this.collaboratorService.addCollaborator(collaborator).subscribe(
			data => {
				//this._successActivity.next('Se registró el colaborador correctamente.');
				this.collaboratorLoading = true
				this.formCollaborator.reset();
				this.loadCollaborators();
			},
			error => {
				console.error('Error al agregar colaborador.');
				console.error(error);
			}
		);
	}
	//#endregion

	//#region Emision Evento: Eliminar Colaborador
	deleteCollaboratorEmit(e) {
		if (e) {
			this.collaboratorLoading = true
			this.loadCollaborators();
		}
	}
	//#endregion

	//#region Permisos para agregar Colaborador
	validateOwner() {
		this.isOwner = (this.dataUser.id == this.requirement['owner'] || this.dataUser.email == this.requirement['owneremail']) ? true : false
	}

	validateCreator() {
		this.isCreator = (this.dataUser.email == this.requirement['creatoremail']) ? true : false
	}
	//#endregion

	/**
	 * Determines if the user has permission to add a collaborator to the request
	 */
	get thisHaveAddColaboratorPermission(){
		return this.isOwner || this.isCreator || this.permissionAddColaborator;
	}

	openModalToCreateCost(idCost: any) {

		let titleModal: string = "";
		let isEdit: boolean = false;

		if (idCost == null || idCost == undefined) {
			isEdit = false;
			titleModal = 'Crear Gasto'
		}
		else {
			isEdit = true;
			titleModal = 'Editar Gasto';
		}

		const modalRef = this.modalService.open(ModalFormCostComponent, {
			scrollable: true, size: 'md', backdrop: 'static',
			keyboard: false
		});

		modalRef.componentInstance.requirementId = this.requirementId;
		modalRef.componentInstance.IdCost = idCost;
		modalRef.componentInstance.titleModal = titleModal;
		modalRef.componentInstance.isEdit = isEdit;

		modalRef.componentInstance.insertCost.subscribe(insertCost => {
			if (insertCost) {
				this.costLoading = true;
				this.loadCosts();
			}
		});
	}

	openModalToCreateFee(idFee: any) {

		let titleModal: string = "";
		let isEdit: boolean = false;

		if (idFee == null || idFee == undefined) {
			isEdit = false;
			titleModal = 'Crear Honorario'
		}
		else {
			isEdit = true;
			titleModal = 'Editar Honorario';
		}

		const modalRef = this.modalService.open(ModalFormFeeComponent, {
			scrollable: true, size: 'md', backdrop: 'static',
			keyboard: false
		});

		modalRef.componentInstance.requirementId = this.requirementId;
		modalRef.componentInstance.IdFee = idFee;
		modalRef.componentInstance.titleModal = titleModal;
		modalRef.componentInstance.isEdit = isEdit;
		modalRef.componentInstance.insertCost.subscribe(insertCost => {
			if (insertCost) {
				this.costLoading = true;
				this.loadCosts();
			}
		});
	}

	async aiPrompt() {

		// Disable button while processing
		this.analisys_submitted = true;

		// Reload requirement data before opening AI prompt modal
		const resp = await this._requirements.getRequirementAllData(this.requirementId).toPromise();
		if (!resp['error']) {
			this.requirement = resp['result'];
		}

		const modalRef = this.modalService.open(PromptsAiComponent, {
			scrollable: true, size: 'lg', backdrop: 'static',
			keyboard: false
		});
		modalRef.componentInstance.requirementId = this.requirementId;
		modalRef.componentInstance.titleModal = "Legal Analytics";

		if (this.requirement["airesponseobject"]) {
			const relevantData = this.requirement["airesponseobject"].output.find(item => item.type === 'message');
			if (relevantData) {
				const relevantDataObject = JSON.parse(relevantData.content[0].text);
				const relevantDataObjectWithoutSummary = Object.entries(relevantDataObject)
					.filter(([key]) => key !== 'resumen_analisis')
					.reduce((obj, [key, value]) => ({...obj, [key]: value}), {});
				modalRef.componentInstance.summaryData = {
					summary: this.requirement["airesume"],
					relevantData: relevantDataObjectWithoutSummary
				}
			}
		}
		this.analisys_submitted = false;
	}

  getCurrentUrl(): string {
    return window.location.href;
  }

  get haveIaDocument(): boolean {
    return this.requirement["config"] &&
    this.requirement["config"].iadocument &&
    this.requirement["config"].iadocument.visible;
  }

  private get portalChatDomainConfig(): Record<string, unknown> {
    return {
      trackvision: {
        modCounterpartyWidthCustomfields: this.domainConfigComponent.isPortalChatCounterparty(),
      },
    };
  }

  get portalChatEvaluation() {
    return evaluateRequirementPortalChat(
      this.requirement?.config,
      this.portalChatDomainConfig
    );
  }

  /** Sidebar: chat operativo (portalChat válido). */
  get hasPortalChatEnabled(): boolean {
    return this.portalChatEvaluation.state === 'active';
  }

  /** Sidebar: portalChat solicitado pero config incompleta (p. ej. clientChat legado sin migrar). */
  get hasPortalChatMisconfigured(): boolean {
    return this.portalChatEvaluation.state === 'misconfigured';
  }

  /** Sidebar: mostrar ícono/sección (activo o mal configurado). */
  get hasPortalChatSectionVisible(): boolean {
    return this.hasPortalChatEnabled || this.hasPortalChatMisconfigured;
  }


  generateIADocument(){
    this.loadingIA=true;
    this._requirements.generateIADocument(this.requirementId).subscribe((resp)=> {
      this.loadingIA=false;
      const confirmModal = this.modalService.open(AlertActionModalComponent, { size: 'sm', centered: true });
      confirmModal.componentInstance.message = `${resp["result"].message}`;
      this.loadFiles();
      this.loadHistory();


    });
  }

  async completedActivity(id){
	await this._requirements.completedActivity({id});
	this.loadAlerts();
  }

  loadAvailableSignatures() {
    this.signatureService.getAvailableSignatures().subscribe(
      (response) => {
        this.advancedSignaturesAvailable = response && response.result ? response.result.avanzadasDisponibles : null;
      },
      (error) => {
        console.error('Error al cargar firmas disponibles:', error);
      }
    );
  }

  editOnline(fileId: number) {
    const dismissed = localStorage.getItem('editOnline_dismiss');
    const proceed = () => {
      this.attachmentsService.getEditUrl(fileId).subscribe((resp: any) => {
        if (resp.result && resp.result.config && resp.result.onlyofficeUrl) {
          const configB64 = btoa(unescape(encodeURIComponent(JSON.stringify(resp.result.config))));
          window.open(`${environment.apiUrl}/onlyoffice/editor?config=${configB64}`, '_blank');
        } else {
          alert('Error al obtener configuración del editor');
        }
      });
    };

    if (!dismissed) {
      if (confirm('El editor se abrirá en una nueva pestaña.\nPara volver, usa el botón Atrás del navegador o cierra la pestaña.\n\nPresiona Aceptar para continuar (no se mostrará de nuevo).')) {
        localStorage.setItem('editOnline_dismiss', '1');
        proceed();
      }
    } else {
      proceed();
    }
  }

  viewOnline(fileId: number) {
    this.attachmentsService.getEditUrl(fileId, 'view').subscribe((resp: any) => {
      if (resp.result && resp.result.config && resp.result.onlyofficeUrl) {
        const configB64 = btoa(unescape(encodeURIComponent(JSON.stringify(resp.result.config))));
        window.open(`${environment.apiUrl}/onlyoffice/editor?config=${configB64}`, '_blank');
      }
    });
  }

  ngOnDestroy() {
    if (this._onFocus) window.removeEventListener('focus', this._onFocus);
  }

}
